import { jsxs as a, jsx as l } from "react/jsx-runtime";
const e = (s) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...s,
    children: [
      /* @__PURE__ */ a("g", { clipPath: "url(#hubspot_svg__a)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#FF7A59",
            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M14.62 14.647a1.614 1.614 0 0 1-1.622-1.606c0-.886.726-1.606 1.622-1.606s1.624.72 1.624 1.606-.727 1.606-1.624 1.606m.487-4.697V8.52a1.1 1.1 0 0 0 .64-.991v-.033c0-.604-.5-1.099-1.11-1.099h-.033c-.61 0-1.11.495-1.11 1.099v.033a1.1 1.1 0 0 0 .64.991v1.43a3.17 3.17 0 0 0-1.496.651l-3.963-3.05q.04-.152.044-.309c0-.684-.56-1.24-1.252-1.242a1.244 1.244 0 0 0-1.253 1.238 1.246 1.246 0 0 0 1.868 1.074l3.9 3.003a3.1 3.1 0 0 0 .048 3.522l-1.187 1.174A1.017 1.017 0 1 0 10.55 18c.569 0 1.03-.456 1.03-1.018a1 1 0 0 0-.048-.291l1.172-1.161a3.17 3.17 0 0 0 1.917.644c1.75 0 3.166-1.402 3.166-3.133 0-1.566-1.163-2.859-2.68-3.091",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "hubspot_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  }
);
export {
  e as default
};
